import _ from 'lodash';

import { checkIsRecipientCopy } from 'utils/documents';

// A copy whose master is not in the same list (deleted, rejected, moved, filtered out by
// search) stays a row of its own instead of disappearing.
export const groupRecipientCopiesByMaster = documents => {
  const documentIds = new Set(documents.map(({ id }) => id));
  const [nestedCopies, rows] = _.partition(
    documents,
    document => checkIsRecipientCopy(document) && documentIds.has(document.RecipientCopyOf),
  );
  const copiesByMasterId = _.groupBy(nestedCopies, 'RecipientCopyOf');

  return rows.map(document => ({
    document,
    recipientCopies: copiesByMasterId[document.id] ?? [],
  }));
};
